module.exports = __webpack_public_path__ + "img/clase_pelea.ccaaac9b.webp";